import { render, staticRenderFns } from "./wrapped-share-dialog.vue?vue&type=template&id=af4d9dda&scoped=true&"
import script from "./wrapped-share-dialog.vue?vue&type=script&lang=js&"
export * from "./wrapped-share-dialog.vue?vue&type=script&lang=js&"
import style0 from "./wrapped-share-dialog.vue?vue&type=style&index=0&id=af4d9dda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4d9dda",
  null
  
)

export default component.exports